import { combineReducers } from 'redux';

import common from './common';
import details from './details';
import exportReducer from './export';
import questionSelfService from './questionSelfService';
import selfServiceDetails from './selfServiceDetails';

/**
 * @typedef {{
 *  common: import('./common').StatisticsUICommonReducer,
 *  export: import('./export').StatisticsUIExportReducer,
 *  details: import('./details').StatisticsUIDetailsReducer,
 *  selfServiceDetails: import('./selfServiceDetails').SelfServiceDetailsUIReducer
 * }} StatisticsUIReducer
 */
export default combineReducers({
  export: exportReducer,
  common,
  details,
  questionSelfService,
  selfServiceDetails,
});
